module.exports = __webpack_public_path__ + "static/media/Canvas_508-05.81641f47.jpg";